import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

const Header = () => {
    const session = useSelector((state) => state.session);
    let search_box = React.useRef();

    const search = (e) => {
        e.preventDefault();
        if (!search_box.current.value) {
            return;
        }
        let url = `/search/${encodeURIComponent(search_box.current.value)}`;
        window.location = url;
    };

    return (
        <header className="site-header no-print">
            <div className="branding">
                <h1>
                    <a href="/">Playaway Admin</a>
                </h1>
            </div>
            <div className="search">
                {session.is_authenticated && (
                    <form action="" id="js-org-lookup" onSubmit={search}>
                        <input
                            ref={search_box}
                            className="col-12 input-collapse"
                            type="text"
                            id="org_key"
                            placeholder="Search by User Email, Org Name, Org NetSuite ID"
                        />
                    </form>
                )}
            </div>
            {session.is_authenticated && (
                <div className="actions">
                    <Link to={`/customer/${session._id}`} className="button button-text">
                        My Account
                    </Link>
                </div>
            )}
            {session.is_authenticated && (
                <div className="actions">
                    <Link to="/logout" className="button button-text">
                        Logout
                    </Link>
                </div>
            )}
        </header>
    );
};

export default Header;
